/* Kala Futurism v1.1 — motion + interaction engine */
(function () {
  'use strict';
  const doc = document;
  const html = doc.documentElement;
  const body = doc.body;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouch = ('ontouchstart' in window) && navigator.maxTouchPoints > 0;
  const isDesktop = window.matchMedia('(min-width: 901px) and (hover: hover)').matches;
  html.classList.add('kf-ready');
  body.classList.add('kala-fx');

  /* Scroll progress rail */
  (function progressRail() {
    const rail = doc.createElement('div');
    rail.className = 'kf-progress';
    body.appendChild(rail);
    let ticking = false;
    function update() {
      const scrollTop = window.scrollY;
      const docHeight = doc.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      rail.style.setProperty('--kf-scroll', pct + '%');
      if (scrollTop > 40) body.classList.add('kf-scrolled');
      else body.classList.remove('kf-scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* Custom cursor */
  if (isDesktop && !isTouch && !prefersReduced) {
    const ring = doc.createElement('div');
    ring.className = 'kf-cursor';
    const dot = doc.createElement('div');
    dot.className = 'kf-cursor-dot';
    body.appendChild(ring);
    body.appendChild(dot);
    let mx = -100, my = -100, rx = -100, ry = -100, dx = -100, dy = -100, visible = false;
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!visible) { visible = true; body.classList.add('kf-cursor-on'); }
    }, { passive: true });
    window.addEventListener('mouseleave', function () {
      visible = false; body.classList.remove('kf-cursor-on');
    });
    function tick() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      dx += (mx - dx) * 0.42; dy += (my - dy) * 0.42;
      ring.style.transform = 'translate3d(' + (rx - 16) + 'px,' + (ry - 16) + 'px,0)';
      dot.style.transform  = 'translate3d(' + (dx - 2)  + 'px,' + (dy - 2)  + 'px,0)';
      requestAnimationFrame(tick);
    }
    tick();
    function bindHover() {
      const hotSelectors = ['a','button','[role="button"]','.kf-btn','input[type="submit"]','input[type="button"]','[data-fx-hot]','label[for]','summary'].join(',');
      doc.querySelectorAll(hotSelectors).forEach(function (el) {
        if (el.dataset.kfBound) return;
        el.dataset.kfBound = '1';
        el.addEventListener('mouseenter', function () {
          if (el.matches('.kf-btn, [data-fx-hot]')) body.classList.add('kf-cursor-hot');
          else body.classList.add('kf-cursor-link');
        });
        el.addEventListener('mouseleave', function () {
          body.classList.remove('kf-cursor-hot', 'kf-cursor-link');
        });
      });
      doc.querySelectorAll('input[type="text"], input[type="email"], input[type="search"], textarea').forEach(function (el) {
        if (el.dataset.kfBoundTxt) return;
        el.dataset.kfBoundTxt = '1';
        el.addEventListener('mouseenter', function () { body.classList.add('kf-cursor-text'); });
        el.addEventListener('mouseleave', function () { body.classList.remove('kf-cursor-text'); });
      });
    }
    bindHover();
    const rebindObserver = new MutationObserver(function () {
      clearTimeout(window.__kfRebind);
      window.__kfRebind = setTimeout(bindHover, 200);
    });
    rebindObserver.observe(body, { childList: true, subtree: true });
    const darkObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio > 0.35) {
          body.classList.add('kf-cursor-dark');
        } else {
          const anyDark = Array.from(doc.querySelectorAll('[data-kf-dark]')).some(function (el) {
            const r = el.getBoundingClientRect();
            return r.top < window.innerHeight * 0.5 && r.bottom > window.innerHeight * 0.5;
          });
          if (!anyDark) body.classList.remove('kf-cursor-dark');
        }
      });
    }, { threshold: [0.35, 0.65] });
    doc.querySelectorAll('[data-kf-dark]').forEach(function (el) { darkObserver.observe(el); });
  }

  /* Reveal engine */
  (function reveal() {
    const items = doc.querySelectorAll('[data-fx]');
    if (!items.length) return;
    if (prefersReduced) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
    doc.querySelectorAll('[data-fx-stagger]').forEach(function (parent) {
      Array.from(parent.children).forEach(function (child, i) { child.style.setProperty('--i', i); });
    });
    // Fallback: force reveal after 5s in case IO fails
    setTimeout(function() {
      items.forEach(function (el) { if (!el.classList.contains('is-in')) el.classList.add('is-in'); });
    }, 5000);
  })();

  /* Split-text titles — split by WORD (not char) to avoid mid-word wraps */
  (function splitText() {
    if (prefersReduced) return;
    doc.querySelectorAll('[data-fx-split]').forEach(function (el) {
      if (el.dataset.kfSplit) return;
      el.dataset.kfSplit = '1';
      // Preserve inline HTML like <em>. Walk children and wrap only text nodes' words.
      function processNode(node) {
        const kids = Array.from(node.childNodes);
        kids.forEach(function (kid) {
          if (kid.nodeType === Node.TEXT_NODE) {
            const frag = doc.createDocumentFragment();
            // Split preserving whitespace tokens
            const parts = kid.textContent.split(/(\s+)/);
            parts.forEach(function (part) {
              if (part.match(/^\s+$/)) {
                frag.appendChild(doc.createTextNode(part));
              } else if (part.length > 0) {
                const wrap = doc.createElement('span');
                wrap.className = 'kf-split-word';
                wrap.style.display = 'inline-block';
                wrap.style.overflow = 'hidden';
                wrap.style.verticalAlign = 'baseline';
                const inner = doc.createElement('span');
                inner.className = 'kf-split-char';
                inner.textContent = part;
                wrap.appendChild(inner);
                frag.appendChild(wrap);
              }
            });
            node.replaceChild(frag, kid);
          } else if (kid.nodeType === Node.ELEMENT_NODE) {
            processNode(kid);
          }
        });
      }
      processNode(el);
      // Set indices
      el.querySelectorAll('.kf-split-char').forEach(function (span, i) {
        span.style.setProperty('--i', i);
      });
    });
  })();

  /* Magnetic buttons */
  if (isDesktop && !prefersReduced) {
    doc.querySelectorAll('[data-fx-magnet]').forEach(function (el) {
      const strength = parseFloat(el.dataset.fxMagnet) || 0.3;
      const inner = el.firstElementChild || el;
      let raf = null;
      el.addEventListener('mousemove', function (e) {
        const rect = el.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px)';
          inner.style.transform = 'translate(' + (x * strength * 0.4) + 'px,' + (y * strength * 0.4) + 'px)';
        });
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; inner.style.transform = ''; });
    });
  }

  /* Parallax hero backgrounds */
  if (!prefersReduced) {
    const parallaxTargets = doc.querySelectorAll('[data-fx-parallax]');
    if (parallaxTargets.length) {
      function updateParallax() {
        parallaxTargets.forEach(function (el) {
          const speed = parseFloat(el.dataset.fxParallax) || 0.15;
          const rect = el.getBoundingClientRect();
          const centerOffset = rect.top + rect.height / 2 - window.innerHeight / 2;
          el.style.setProperty('--kf-parallax', (-centerOffset * speed) + 'px');
        });
      }
      window.addEventListener('scroll', updateParallax, { passive: true });
      updateParallax();
    }
  }

  /* Chapter rail */
  (function chapterRail() {
    const rail = doc.querySelector('[data-kf-rail]');
    if (!rail) return;
    const items = rail.querySelectorAll('.kf-rail__item');
    const targets = Array.from(items).map(function (it) {
      const sel = it.getAttribute('data-target');
      return sel ? doc.querySelector(sel) : null;
    });
    setTimeout(function () { rail.classList.add('is-on'); }, 800);
    items.forEach(function (item, i) {
      item.addEventListener('click', function () {
        if (targets[i]) targets[i].scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
    function updateActive() {
      let activeIdx = 0;
      const midY = window.innerHeight * 0.4;
      targets.forEach(function (t, i) {
        if (!t) return;
        const r = t.getBoundingClientRect();
        if (r.top <= midY) activeIdx = i;
      });
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === activeIdx); });
      const active = targets[activeIdx];
      if (active && active.hasAttribute('data-kf-dark')) rail.dataset.theme = 'dark';
      else rail.removeAttribute('data-theme');
    }
    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  })();

  /* Numeric ticker */
  (function tickers() {
    if (prefersReduced) {
      doc.querySelectorAll('.kf-ticker').forEach(function (el) { el.textContent = el.dataset.value || el.textContent; });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        const el = e.target;
        io.unobserve(el);
        const target = parseFloat(el.dataset.value);
        if (isNaN(target)) return;
        const decimals = parseInt(el.dataset.decimals || '0', 10);
        const prefix = el.dataset.prefix || '';
        const suffix = el.dataset.suffix || '';
        const duration = parseInt(el.dataset.duration || '1400', 10);
        const start = performance.now();
        function step(now) {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          const val = target * eased;
          el.textContent = prefix + val.toFixed(decimals) + suffix;
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    doc.querySelectorAll('.kf-ticker').forEach(function (el) { io.observe(el); });
  })();

  /* Page transition overlay: entrance sweep only. Do NOT intercept nav clicks. */
  (function pageTransition() {
    if (prefersReduced) return;
    const overlay = doc.createElement('div');
    overlay.className = 'kf-transition';
    overlay.innerHTML = '<span class="kf-transition__mark">Kala</span>';
    body.appendChild(overlay);
    overlay.classList.add('is-in');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.remove('is-in');
        overlay.classList.add('is-out');
        setTimeout(function () { overlay.classList.remove('is-out'); overlay.style.transform = ''; }, 900);
      });
    });
  })();

  /* Do NOT auto-elevate homepage — the Kala Futurism home section owns its own reveals. */
})();
